/**
 * Initial state for the Layers Manager
 */
export default function() {
  return {
    layers: {},
    layersById: {},
    activeLayers: {},
    overlays: {},
    overlaysById: [],
    activeOverlays: [],
  };
}
